import Box from '@mui/material/Box';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import IconLogoIEntry from '../assets/images/sklut_horizontal.png';

const NotFound = () => {
    const navigate = useNavigate();

    const goBack = () => navigate(-1);
    return (
        <Box className='notFound'>
            <Box>
                <img src={IconLogoIEntry} height={300} className={'filter-brightness-85'} alt={"logo"}/>
            </Box>
            <Box className='notfoundtext'>
                <Box className='item'>
                    <h1>404</h1>
                    <p>
                        OOPS! PAGE <br />
                        NOT FOUND.
                    </p>
                    <button onClick={goBack}>
                        BACK TO HOME <i className='fa fa-home' aria-hidden='true'></i>
                    </button>
                </Box>
            </Box>
        </Box>
    );
};

export default NotFound;
